<template>
    <v-layout justify-center row>
        <v-dialog
                :item="item"
                v-model="show"
                width="500"
        >
            <v-card>
                <v-toolbar color="primary" v-if="item">
                    <v-toolbar-title class="white--text" v-if="isPackage(item)">
                        Paket ‎<strong>{{ item.name }}</strong>‏‏‎ ‎löschen?
                    </v-toolbar-title>

                    <v-toolbar-title class="white--text" v-if="isFolder(item)">
                        Ordner ‎<strong>{{ item.name }}</strong>‏‏‎ ‎löschen?
                    </v-toolbar-title>

                    <v-toolbar-title class="white--text" v-if="isFile(item)">
                        ‎Datei <strong>{{ item.filename }}</strong>‏‏‎ ‎löschen?
                    </v-toolbar-title>

                    <v-toolbar-title class="white--text" v-if="isClient(item)">
                        Mandant ‎<strong>{{ item.name }}</strong>‏‏‎ ‎löschen?
                    </v-toolbar-title>
                </v-toolbar>

                <v-card-text>
                    Dieser Vorgang kann nicht rückgängig gemacht werden.
                </v-card-text>

                <v-divider/>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                            @click="show = false"
                            color="primary">
                        Nein
                    </v-btn>
                    <v-btn
                            @click="deleteItem"
                            color="primary">
                        Ja
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import DeleteDialogStore from "@/ts/stores/DeleteDialogStore";
    import Folder from "@/ts/interfaces/Folder";
    import File from "@/ts/interfaces/File";
    import Package from "@/ts/interfaces/Package";
    import Mandates from "@/views/Mandates";
    import Client from "@/ts/interfaces/Client";

    export default {
        name: "DeleteDialog",

        data() {
            return {
                state: DeleteDialogStore.state,
                show: false
            }
        },
        props: {
            value: Boolean,
            item: {}
        },
        watch: {
            state: {
                handler() {
                    this.show = this.state.dialogVisible;
                },
                deep: true
            },
            show(val) {
                if (!val) {
                    this.close()
                }
            }
        },
        methods: {
            isPackage(item) {
                return item instanceof Package
            },
            //TODO later this is pretty dirty but is a quick & dirty 'fix'
            isFolder(item) {
                return item.hasOwnProperty("folder_type")
            },
            isFile(item) {
                return item.hasOwnProperty("subject")
            },
            isClient(item) {
                return item.hasOwnProperty("user_accounts")
            },
            close() {
                DeleteDialogStore.dismiss()
            },
            deleteItem() {
                this.$emit('deleteClick');
            }
        }
    }
</script>
